import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import getBackendUrl from "../../../environment/BackendService";
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";


const useLicsScheduleDetail = () => {
  const { MEDICARE_LICS_SCHEDULE } = ROUTE_PATHS;
  const location = useLocation();
  const { state: stateVal } = location;
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  console.log("current state in form", currentState, previousState);
  const {
    selectedSchedules = [],
    previousScreen = MEDICARE_LICS_SCHEDULE,
    currentIndex: initialIndex = 0,
    displayMode = false,
    initialParamsData = {
      lscLicsScheduleName: selectedSchedules[initialIndex]?.lscLicsScheduleName,
      lcsLicsScheduleDesc: selectedSchedules[initialIndex]?.lcsLicsScheduleDesc,
    }
  } = currentState;
console.log("sel sch", selectedSchedules);
  const [data, setData] = useState([]); /* LICS Schedule Detail Data */
  const [paramsData, setParamsData] = useState(initialParamsData); /* */
  const { axios_helper_no_header } = useAxios();
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const navigateToPage = useCustomNavigate();
  const toast = useToast();

  const screen_title = "LICS Schedule Detail";
  const screenNumber = "RCLSD001";

  /* Search form fields that needs to be shown for filtering */
  const formFields = [
    {
      fieldLabel: "Schedule",
      name: "lscLicsScheduleName",
      label: "Schedule",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 10,
    },
    {
      fieldLabel: "Description",
      name: "lcsLicsScheduleDesc",
      label: "Description",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 25,
    },
  ];

  const handleBack = useCallback(() => {
    if (currentIndex < selectedSchedules.length - 1) {
        setCurrentIndex(currentIndex + 1);
    } else {
      const lastScheduleName =
      selectedSchedules[currentIndex]?.lscLicsScheduleName || "";
    const updatedParamsData = {
      ...currentState.paramsData,
      lscLicsScheduleName: lastScheduleName,
    };

    // force the back button on the previous screen when needed.
    previousState[0].hasBack = currentState.hasBack;

      navigateToPage(previousScreen, [
        ...previousState
      ]);
    }
  }, [currentIndex, selectedSchedules]);

  const leftButtons = [{ button_label: 'Back', button_handeler: handleBack, button_key: "F12" }];


  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = [
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    }
  ];

  /* Gear Icon Menu option CTAs */
  const menuOptions = [

  ];

  /* Data table column info. */
  const columnDef = [
    {
      header: "Coverage Phase",
      field: "lsdLicsPhase",
    },
    {
      header: "Deductible Amount",
      field: "lsdDeductibleAmount",
    },
    {
      header: "Patient Pay Brand Amount",
      field: "lsdBrandCopayAmount",
    },
    {
      header: "Patient Pay Brand Percent",
      field: "lsdBrandPercentAmt",
    },
    {
      header: "Patient Pay Generic Amount",
      field: "lsdGenericCopayAmount",
    },
    {
      header: "Patient Pay Generic Percent",
      field: "lsdGenericPercentAmt",
    },
  ];

  /* Param Key which used as bridge between various operations on tabluar data */
  const parmKey = "lsdLicsPhase";

  /* Handler that fetches the data */
  const fetchData = async () => {
    console.log("fetch data");
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/lsdLicsScheduleDtl`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        console.log("response.length is ", response.length);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        console.log("response", response);
        console.log(pageResponse.totalRecords);
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords  
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  useEffect(() => {
    fetchData(); // Initial fetch with page 0 and page size 10  
  }, [paramsData, rows, currentPage]);

  const onPageChange = (event) => {
    console.log("page change", event.first, event);
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  useEffect(()=>{
  if(currentIndex!=initialIndex){
  setParamsData({
  lscLicsScheduleName: selectedSchedules[currentIndex].lscLicsScheduleName,
  lcsLicsScheduleDesc: selectedSchedules[currentIndex].lcsLicsScheduleDesc,
  });
  }
  },[currentIndex]);

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/lsdLicsScheduleDtl/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    paramsData,
    updateParamData,
    ctaButtons,
    leftButtons,
    data,
    parmKey,
    displayMode,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
  };
};

export default useLicsScheduleDetail;